/**
 * A label table as the choices a control offers.
 *
 * Generic in the key, so a table declared `satisfies Record<Enum, string>`
 * hands back options typed by that enum — a control taking the member keeps
 * checking its handler rather than being handed a bare string.
 */
export const optionsOf = <K extends string>(labels: Record<K, string>) =>
  (Object.entries(labels) as Array<[K, string]>).map(([value, label]) => ({
    value,
    label,
  }))
